'use client';
import React, { Suspense } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { pageVariants, reducedMotionVariants } from '@/lib/animations';
import SignUpLoginContent from '../sign-up-login-screen/components/SignUpLoginContent';

export default function LoginPage() {
  const shouldReduceMotion = useReducedMotion();
  const variants = shouldReduceMotion ? reducedMotionVariants : pageVariants;

  return (
    <motion.div
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      style={{ width: '100%', height: '100%' }}
    >
      <Suspense fallback={<div />}>
        <SignUpLoginContent />
      </Suspense>
    </motion.div>
  );
}
